import React from "react";
import './App.css';
import Navbar from './component/Navber';
import Hero from './component/Hero';
import Footer from "./component/Footer";

function App() {
  return (
<>
    <Navbar />
    <Hero />
   <Footer />
</>

  );
}

export default App;
